module.exports = __webpack_public_path__ + "img/wxcess.ae5e7c06.png";